import { graphApiBaseUrl } from '../../config';
import { base64toFile } from '../../utils/fileUtils';
import { fetchWithRetry } from '../../utils/retryUtils';

export const getAttachmentContent = async (
  token: string,
  messageId: string,
  attachmentId: string,
): Promise<File | null> => {
  const attachmentContentUrl = `${graphApiBaseUrl}/me/messages/${messageId}/attachments/${attachmentId}`;

  try {
    const response = await fetchWithRetry(attachmentContentUrl, {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });

    if (!response.ok) {
      // Handle specific errors
      if (response.status === 401 || response.status === 403) {
        console.error(
          `Graph API Auth Error (${response.status}) fetching attachment content for att ID ${attachmentId}.`,
        );
      } else if (response.status === 429) {
        console.error(
          `Graph API Throttling (${response.status}) fetching attachment content for att ID ${attachmentId}. Max retries exceeded.`,
        );
      } else if (response.status === 503) {
        console.warn(
          `Graph API Unavailable (${response.status}) fetching attachment content for att ID ${attachmentId}.`,
        );
      } else {
        const errorText = await response.text(); // Try to get error text
        console.error(
          `Graph API error fetching attachment content for att ID ${attachmentId} (Status ${response.status}): ${errorText}`,
        );
      }
      return null; // Indicate failure
    }

    // Get the response body as a Blob
    const attachmentData = await response.json();

    return base64toFile(attachmentData.contentBytes, attachmentData.name);
  } catch (error) {
    console.error(
      `Network or other error fetching attachment content for att ID ${attachmentId}:`,
      error,
    );

    return null; // Indicate failure
  }
};
